import Constants from '@/Constants';
import { ChangePasswordData, IntegrationLoginData, LoginData } from '@/models/LoginData';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import http from '@/services/HttpService';
import { AxiosError } from 'axios';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    acceptTermsFailure,
    acceptTermsSuccess,
    authFailure,
    authIntegrationFailure,
    authIntegrationSuccess,
    authSuccess,
    changePasswordFailure,
    changePasswordSuccess,
    forgotPasswordFailure,
    forgotPasswordSuccess
} from './action';
import { IdentityTypes } from './types';

export function* auth(action: PayloadAction<IdentityTypes.AUTH_REQUEST, LoginData>) {
    try {
        const { data } = yield call(http.post, Constants.LOGIN_URI, action.payload);
        analyticsService.logEvent(FlowEvents.LOGIN);
        yield put(authSuccess(data));
    } catch (error) {
        yield put(authFailure(error as AxiosError));
    }
}

export function* authSAML(action: PayloadAction<IdentityTypes.AUTH_SAML_REQUEST, { bearerToken: string }>) {
    try {
        const { data } = yield call(http.post, Constants.LOGIN_BEARER_URI, { token: action.payload });
        analyticsService.logEvent(FlowEvents.LOGIN);
        yield put(authSuccess(data));
    } catch (error) {
        yield put(authFailure(error as AxiosError));
    }
}

export function* acceptTermsRequest(action: PayloadAction<IdentityTypes.ACCEPT_TERMS_REQUEST, { personId: number }>) {
    try {
        yield call(http.put, Constants.ACCEPT_TERMS_URI.replace('%p', action.payload.personId.toString()));
        yield put(acceptTermsSuccess());
    } catch (error) {
        yield put(acceptTermsFailure(error as AxiosError));
    }
}

export function* forgotPasswordRequest(action: PayloadAction<IdentityTypes.FORGOT_PASSWORD_REQUEST, LoginData>) {
    try {
        yield call(http.post, Constants.FORGOT_PASSWORD_URI, action.payload);
        yield put(forgotPasswordSuccess());
    } catch (error) {
        yield put(forgotPasswordFailure(error as AxiosError));
    }
}

export function* changePasswordRequest(action: PayloadAction<IdentityTypes.CHANGE_PASSWORD_REQUEST, ChangePasswordData>) {
    try {
        yield call(http.put, `${Constants.CHANGE_PASSWORD_URI}/${action.payload.userId}`, action.payload);
        yield put(changePasswordSuccess());
    } catch (error) {
        yield put(changePasswordFailure(error as AxiosError));
    }
}

export function* integrationAuth(action: PayloadAction<IdentityTypes.AUTH_INTEGRATION_REQUEST, IntegrationLoginData>) {
    try {
        const { data } = yield call(http.post, Constants.LOGIN_INTEGRATION_URI, action.payload);
        analyticsService.logEvent(FlowEvents.LOGIN);
        yield put(authIntegrationSuccess(data));
    } catch (error) {
        yield put(authIntegrationFailure(error as AxiosError));
    }
}
